"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var NavItem = /** @class */ (function (_super) {
    __extends(NavItem, _super);
    function NavItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isCollapsed: false, isCollapsible: true };
        _this.dispatchOnClick = function () {
            var _a = _this.props, navProp = _a.navProp, pathId = _a.pathId;
            var arg = {
                id: navProp.id,
                path: pathId,
                payload: navProp.payload
            };
            if (navProp.onClick) {
                try {
                    navProp.onClick(__assign({}, arg));
                }
                catch (e) {
                    // ignored
                }
            }
            if (_this.props.context.onItemSelection) {
                _this.props.context.onItemSelection(arg);
            }
        };
        return _this;
    }
    NavItem.prototype.render = function () {
        var _a = this.props, children = _a.children, context = _a.context, others = __rest(_a, ["children", "context"]);
        var template = this.props.context.template;
        var Template = template.item;
        return (React.createElement("div", { onClick: this.dispatchOnClick, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave },
            React.createElement(Template, __assign({}, others, { style: this.props.navProp.style || {}, className: this.props.navProp.className || '' }), children || null)));
    };
    return NavItem;
}(React.PureComponent));
exports.NavItem = NavItem;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidenav/nav/NavItem.js
// module id = ./node_modules/react-sidenav/nav/NavItem.js
// module chunks = 0